import { Loader2 } from "lucide-react";
import { STATUS, BUSY } from "./socialMeta";

export const StatusBadge = ({ status, testId }) => {
  const s = STATUS[status] || STATUS.planned;
  return (
    <span data-testid={testId} className={`inline-flex items-center gap-1 px-2.5 py-1 rounded-full text-[11px] font-bold ${s.cls}`}>
      {BUSY.includes(status) && <Loader2 className="w-3 h-3 animate-spin" />}
      {s.label}
    </span>
  );
};
